<template>
  <ResponsivePopoverView v-model:active="editing" placement="bottom" class="d-inline-block">
    <template v-slot:target>
      <ButtonView type="shaded" color="foreground" size="small" @click="editor.chain().focus().extendMarkRange('link').run(); editing = true">
        <i class="fas fa-edit fa-fw"></i>
      </ButtonView>
    </template>
    <template v-slot:body>
      <LinkFormView :editor="editor" @submit="editing = false"/>
    </template>
  </ResponsivePopoverView>
  <ButtonView type="shaded" color="foreground" size="small" @click="openInNewTab">
    <i class="fas fa-arrow-up-right-from-square fa-fw"></i>
  </ButtonView>
  <ButtonView type="shaded" color="foreground" size="small" @click="editor.chain().focus().unsetLink().run()">
    <i class="fas fa-unlink fa-fw"></i>
  </ButtonView>
</template>

<script setup>
import ButtonView from "../../../general/ButtonView.vue";
import LinkFormView from "./LinkFormView.vue";
import {ref} from "vue";
import ResponsivePopoverView from "../../..//general/ResponsivePopoverView.vue";

const props = defineProps({
  editor: Object,
  config: Object
});

function openInNewTab() {
  window.open(props.editor.getAttributes('link').href, "_blank");
}

const editing = ref(false);

</script>